import { Link, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FloatingDecorations, GridPattern } from "./DecorationElements";
import { Footer } from "./Footer";
import { Briefcase, User, PlusSquare } from "lucide-react";
import { FaMagnifyingGlass } from "react-icons/fa6";

export function DesktopLayout({ type }) {
  const location = useLocation();
  const activePath = location.pathname.split("/")[2];

  const { userInfo } = useSelector((state) => state.auth);
  const role = userInfo ? userInfo.user.role : null;
  const isNotAuthorized = userInfo?.user.role === "shoveller" && (userInfo?.user.stripeAccountId === "none" || userInfo?.user.chargesEnabled === false);


  const tabs =
    type === "homeowner"
      ? [
          { label: "Post Job", path: "post", icon: <PlusSquare className="w-5 h-5" />, auth: null },
          { label: "Profile", path: "profile", icon: <User className="w-5 h-5" />, auth: null },
          { label: "Jobs", path: "jobs", icon: <Briefcase className="w-5 h-5" />, auth: null },
        ]
      : [
          { label: "Search Jobs", path: "search", icon: <FaMagnifyingGlass className="w-5 h-5" />, auth: "shoveller" },
          { label: "Profile", path: "profile", icon: <User className="w-5 h-5" />, auth: null },
          { label: "Your Jobs", path: "jobs", icon: <Briefcase className="w-5 h-5" />, auth: "shoveller" },
        ];

  const isDisabled = (tab) => (tab.auth && tab.auth !== role) || (tab.auth === "shoveller" && isNotAuthorized);

  return (
    <div className="min-h-screen bg-white relative">
      <FloatingDecorations />
      <GridPattern />

      {/* Desktop Nav Tabs */}
      <div className="relative max-w-7xl mx-auto px-8 py-8 hidden md:block">
        <div className="flex justify-center">
          <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-black/20 via-gray-500/20 to-black/20 rounded-lg blur-sm" />
            <div className="relative grid w-full max-w-md grid-cols-3 bg-white shadow-lg border p-1 rounded-lg">
              {tabs.map((tab) => {
                const disabled = isDisabled(tab);
                return (
                  <Link
                    key={tab.path}
                    to={disabled ? "#" : tab.path}
                    onClick={(e) => disabled && e.preventDefault()}
                    className={`text-sm font-medium px-4 py-2 text-center rounded-md transition-all duration-200 ${
                      disabled
                        ? "cursor-not-allowed text-gray-400 bg-gray-50"
                        : activePath === tab.path
                        ? "bg-black text-white"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    {tab.label}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Page Content */}
      <div className="relative max-w-7xl mx-auto px-4 md:px-8 md:pb-16 pb-20">
        <Outlet />
      </div>

      {/* Mobile Bottom Nav */}
      <div className="md:hidden fixed bottom-0 left-0 w-full border-t bg-white shadow-lg z-50">
        <div className="flex justify-around">
          {tabs.map((tab) => {
            const disabled = isDisabled(tab);
            return (
              <Link
                key={tab.path}
                to={disabled ? "#" : tab.path}
                onClick={(e) => disabled && e.preventDefault()}
                className={`flex flex-col items-center justify-center py-2 text-xs transition-colors duration-200 ${
                  disabled
                    ? "text-gray-400 cursor-not-allowed"
                    : activePath === tab.path
                    ? "text-black"
                    : "text-gray-500 hover:text-black"
                }`}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Footer (only >= lg) */}
      <div className="hidden lg:block">
        <Footer />
      </div>
    </div>
  );
}
